<template>
<v-card flat :disabled="load" :loading="load">
    <!-- {{dias}} -->
  <v-card-title>Estatistica de liberação por hora</v-card-title>
  <div id="chart">
    <apexchart v-if="series[0].data.length > 0" type="line" height="350" :options="chartOptions" :series="series"></apexchart>
  </div>
</v-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import service from './../services/userservice'
export default {
  name: 'estatisticasHora',
  components: {
    apexchart: VueApexCharts
  },
  mounted () {
    this.carregarEstatisticasHoras()
  },
  data () {
    return {
      load: false,
      selection: '',
      dias: null,
      liberacoes: '',
      mLiberacao: '',
      series: [{
        name: '',
        data: []
      },
      {
        name: '',
        data: []
      }
      ],
      chartOptions: {
        chart: {
          id: 'myChart',
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: [5, 7, 5],
          curve: 'straight',
          dashArray: [0, 8, 5]
        },
        // title: {
        //   text: 'Page Statistics',
        //   align: 'left'
        // },
        legend: {
          tooltipHoverFormatter: function (val, opts) {
            return val + ' - ' + opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] + ''
          }
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6
          }
        },
        xaxis: {
          categories: []
        },
        tooltip: {
          y: [{
            title: {
              formatter: function (val) {
                return val + ' (OS)'
              }
            }
          },
          {
            title: {
              formatter: function (val) {
                return val + ' (OS)'
              }
            }
          },
          {
            title: {
              formatter: function (val) {
                return val
              }
            }
          }
          ]
        },
        grid: {
          borderColor: '#f1f1f1'
        }
      }
    }
  },
  methods: {
    carregarEstatisticasHoras () {
      var hoje = new Date()

      var ontem = new Date(hoje.getTime())
      ontem.setDate(hoje.getDate() - 1)

      var dd = ontem.getDate()
      var mm = ontem.getMonth() + 1
      var yyyy = ontem.getFullYear()

      if (dd < 10) {
        dd = '0' + dd
      }

      if (mm < 10) {
        mm = '0' + mm
      }
      let ontemok = yyyy + '-' + mm + '-' + dd
      console.log(ontemok)
      let data = {
        idCidadeProcessamento: 0,
        idUnidadeProcessamento: 0,
        idUnidadeNegocio: 0,
        datas: [hoje, ontemok]
      }
      service.estatisticaHora(data).then(r => {
        if (r.status === 200) {
          this.dias = r.data
        }
      }).finally(() => {
        this.load = false
      })
    }
  }
}
</script>
